import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AppliedToplineItem, FieldStatus } from 'generated/graphql';

import { ToplineAddClickedEvent } from '../ToplineAddClickedEvent';

@Component({
  selector: 'app-topline-address',
  templateUrl: './topline-address.component.html',
  // styleUrls: ['./topline-address.component.scss']
})
export class ToplineAddressComponent implements OnInit  {
  @Input() topline: Partial<AppliedToplineItem> | any;
  @Input() targetId: string;
  @Input() targetType: 'Entity' | 'EntityConnection';

  /** Will be used for top topline */
  @Input() truncate: boolean;
  @Output() addClick = new EventEmitter<ToplineAddClickedEvent>();

  cityStateOnly = false;

  constructor() {
  }

  ngOnInit() {
    if (this.topline.toplineItem?.itemType === 'CityState') {
      this.cityStateOnly = true
    };
  }


  onAddClicked() {
    const eventData = { targetType: this.targetType, targetId: this.targetId, topline: this.topline };
    this.addClick.emit(eventData);
  }

  isDoNotContact() {
    return this.topline?.appliedToplineValue?.status === FieldStatus.DoNotContact;
  }

  isBad() {
    return this.topline?.appliedToplineValue?.status === FieldStatus.Bad;
  }
}
